function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "top-up-hi-dark_svg__f"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 76.5,
  cy: 158.5,
  rx: 28,
  ry: 6,
  fill: "none"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "top-up-hi-dark_svg__d"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 68.5,
  cy: 166.5,
  rx: 28,
  ry: 6,
  fill: "none"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "top-up-hi-dark_svg__e"
}, /*#__PURE__*/React.createElement("path", {
  d: "M100.5 158.5v.92c-4.89-1.75-13.8-2.92-24-2.92s-19.11 1.17-24 2.92v-.92h-4v4c0 3.31 12.54 6 28 6s28-2.69 28-6v-4z",
  fill: "none"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "top-up-hi-dark_svg__c"
}, /*#__PURE__*/React.createElement("path", {
  d: "M92.5 166.5v.92c-4.89-1.75-13.8-2.92-24-2.92s-19.11 1.17-24 2.92v-.92h-4v4c0 3.31 12.54 6 28 6s28-2.69 28-6v-4z",
  fill: "none"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "top-up-hi-dark_svg__h"
}, /*#__PURE__*/React.createElement("path", {
  d: "M90.5 150.5v.92c-4.89-1.75-13.8-2.92-24-2.92s-19.11 1.17-24 2.92v-.92h-4v4c0 3.31 12.54 6 28 6s28-2.69 28-6v-4z",
  fill: "none"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "top-up-hi-dark_svg__j"
}, /*#__PURE__*/React.createElement("path", {
  d: "M98.5 142.5v.92c-4.89-1.75-13.8-2.92-24-2.92s-19.11 1.17-24 2.92v-.92h-4v4c0 3.31 12.54 6 28 6s28-2.69 28-6v-4z",
  fill: "none"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "top-up-hi-dark_svg__g",
  x1: 63.09,
  y1: 144.97,
  x2: 90.88,
  y2: 172.76,
  xlinkHref: "#top-up-hi-dark_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "top-up-hi-dark_svg__b",
  x1: 96.5,
  y1: 162.5,
  x2: 96.5,
  y2: 162.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#f6f6f6",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "top-up-hi-dark_svg__i",
  x1: 57.91,
  y1: 136.16,
  x2: 83.69,
  y2: 161.94,
  xlinkHref: "#top-up-hi-dark_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "top-up-hi-dark_svg__a",
  x1: 60.16,
  y1: 152.25,
  x2: 85.78,
  y2: 177.87,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "top-up-hi-dark_svg__k",
  x1: 82,
  y1: 80,
  x2: 110,
  y2: 108,
  xlinkHref: "#top-up-hi-dark_svg__b"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "<Gruppe>"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Bounding Box",
  fill: "none",
  d: "M0 0h192v192H0z"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Mobile_ic_hi"
}, /*#__PURE__*/React.createElement("rect", {
  x: 56,
  y: 16,
  width: 80,
  height: 160,
  rx: 8,
  ry: 8,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128 174H64a8 8 0 01-8-8v2a8 8 0 008 8h64a8 8 0 008-8v-2a8 8 0 01-8 8z",
  opacity: 0.06
}), /*#__PURE__*/React.createElement("rect", {
  x: 60,
  y: 32,
  width: 72,
  height: 122,
  rx: 2,
  ry: 2,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  x: 88,
  y: 24,
  width: 16,
  height: 2,
  rx: 0.71,
  ry: 0.71,
  opacity: 0.12
}), /*#__PURE__*/React.createElement("rect", {
  x: 82,
  y: 24,
  width: 2,
  height: 2,
  rx: 0.71,
  ry: 0.71,
  opacity: 0.12
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Bounding Box",
  fill: "none",
  d: "M0 0h192v192H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f4f4f4",
  d: "M62 34.11h68v118H62z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M92.5 166.5v.92c-4.89-1.75-13.8-2.92-24-2.92s-19.11 1.17-24 2.92v-.92h-4v4c0 3.31 12.54 6 28 6s28-2.69 28-6v-4z",
  fill: "#f4f4f4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M92.5 166.5v.92c-4.89-1.75-13.8-2.92-24-2.92s-19.11 1.17-24 2.92v-.92h-4v4c0 3.31 12.54 6 28 6s28-2.69 28-6v-4z",
  fill: "#f4f4f4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M92.5 166.5v.92c-4.89-1.75-13.8-2.92-24-2.92s-19.11 1.17-24 2.92v-.92h-4v4c0 3.31 12.54 6 28 6s28-2.69 28-6v-4z",
  opacity: 0.06
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.06,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 4,
  clipPath: "url(#top-up-hi-dark_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M44.5 168.5v6M52.5 168.5v8M60.5 168.5v8M68.5 168.5v8M76.5 168.5v8M84.5 168.5v8M92.5 166.5v8"
})), /*#__PURE__*/React.createElement("ellipse", {
  cx: 68.5,
  cy: 166.5,
  rx: 28,
  ry: 6,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#top-up-hi-dark_svg__d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M96.5 166.5c0-3.12-11.1-5.68-25.3-6l-22.41 3.08 8.38 8.42c3.47.33 7.3.51 11.33.51 15.5-.01 28-2.7 28-6.01z",
  opacity: 0.2,
  fill: "url(#top-up-hi-dark_svg__a)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M100.5 158.5v.92c-4.89-1.75-13.8-2.92-24-2.92s-19.11 1.17-24 2.92v-.92h-4v4c0 3.31 12.54 6 28 6s28-2.69 28-6v-4z",
  fill: "#f4f4f4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M100.5 158.5v.92c-4.89-1.75-13.8-2.92-24-2.92s-19.11 1.17-24 2.92v-.92h-4v4c0 3.31 12.54 6 28 6s28-2.69 28-6v-4z",
  fill: "#f4f4f4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M100.5 158.5v.92c-4.89-1.75-13.8-2.92-24-2.92s-19.11 1.17-24 2.92v-.92h-4v4c0 3.31 12.54 6 28 6s28-2.69 28-6v-4z",
  opacity: 0.06
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.06,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 4,
  clipPath: "url(#top-up-hi-dark_svg__e)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M52.5 160.5v6M60.5 160.5v8M68.5 160.5v8M76.5 160.5v8M84.5 160.5v8M92.5 160.5v8M100.5 158.5v8"
})), /*#__PURE__*/React.createElement("ellipse", {
  cx: 76.5,
  cy: 158.5,
  rx: 28,
  ry: 6,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#top-up-hi-dark_svg__f)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M48.83 159.24l1.26 1.26c3.83 2.33 14.21 4 26.41 4 15.46 0 28-2.69 28-6 0-2.15-5.3-4-13.25-5.1z",
  opacity: 0.2,
  fill: "url(#top-up-hi-dark_svg__g)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M90.5 150.5v.92c-4.89-1.75-13.8-2.92-24-2.92s-19.11 1.17-24 2.92v-.92h-4v4c0 3.31 12.54 6 28 6s28-2.69 28-6v-4z",
  fill: "#f4f4f4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.5 150.5v.92c-4.89-1.75-13.8-2.92-24-2.92s-19.11 1.17-24 2.92v-.92h-4v4c0 3.31 12.54 6 28 6s28-2.69 28-6v-4z",
  fill: "#f4f4f4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.5 150.5v.92c-4.89-1.75-13.8-2.92-24-2.92s-19.11 1.17-24 2.92v-.92h-4v4c0 3.31 12.54 6 28 6s28-2.69 28-6v-4z",
  opacity: 0.06
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.06,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 4,
  clipPath: "url(#top-up-hi-dark_svg__h)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M42.5 152.5v6M50.5 152.5v8M58.5 152.5v8M66.5 152.5v8M74.5 152.5v8M82.5 152.5v8M90.5 150.5v8"
})), /*#__PURE__*/React.createElement("ellipse", {
  cx: 66.5,
  cy: 150.5,
  rx: 28,
  ry: 6,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.71 144.51l-21 2.9 8.55 8.59c3.44.32 7.24.5 11.24.5h.6c2.84 0 6.11-.15 9.74-.42 8.39-.71 14.78-2.27 16.9-4.18l.67-.92a1.38 1.38 0 00.09-.47 1.34 1.34 0 000-.28l-1.92-1.92c-3.98-2.16-13.58-3.7-24.87-3.8z",
  opacity: 0.2,
  fill: "url(#top-up-hi-dark_svg__i)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M98.5 142.5v.92c-4.89-1.75-13.8-2.92-24-2.92s-19.11 1.17-24 2.92v-.92h-4v4c0 3.31 12.54 6 28 6s28-2.69 28-6v-4z",
  fill: "#f4f4f4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M98.5 142.5v.92c-4.89-1.75-13.8-2.92-24-2.92s-19.11 1.17-24 2.92v-.92h-4v4c0 3.31 12.54 6 28 6s28-2.69 28-6v-4z",
  fill: "#f4f4f4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M98.5 142.5v.92c-4.89-1.75-13.8-2.92-24-2.92s-19.11 1.17-24 2.92v-.92h-4v4c0 3.31 12.54 6 28 6s28-2.69 28-6v-4z",
  opacity: 0.06
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.06,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 4,
  clipPath: "url(#top-up-hi-dark_svg__j)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M50.5 144.5v6M58.5 144.5v8M66.5 144.5v8M74.5 144.5v8M82.5 144.5v8M90.5 144.5v8M98.5 142.5v8"
})), /*#__PURE__*/React.createElement("ellipse", {
  cx: 74.5,
  cy: 142.5,
  rx: 28,
  ry: 6,
  fill: "#fff"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#e60000",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 8,
  d: "M96 64L82 78M110 78L96 64"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#e60000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 8,
  fill: "url(#top-up-hi-dark_svg__k)",
  d: "M96 122V66"
});

var SvgTopUpHiDark = function SvgTopUpHiDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Apps_ic",
    viewBox: "0 0 192 192",
    "aria-hidden": true
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default SvgTopUpHiDark;